// email в Strapi обязателен, поэтому если его нет — сохраняем заглушку на основе логина
export const placeholderEmail = (username: string) => `${username}@proschoolnsk.ru`

export const isPlaceholderEmail = (email?: string | null, username?: string | null) =>
    !!email && !!username && email.toLowerCase() === placeholderEmail(username).toLowerCase()

export const emailToForm = (email?: string | null, username?: string | null) =>
    !email || isPlaceholderEmail(email, username) ? '' : email

export const emailFromForm = (email: string | undefined, username: string) =>
    email && email.trim().length > 0 ? email.trim() : placeholderEmail(username)
